import type { ReactNode } from 'react';
import React from 'react';

import UFOSuspense from '@atlaskit/react-ufo/suspense';

export type RelaySuspenseProps = {
	children: ReactNode;
	fallback: ReactNode;
	/** A stable name for the UFO hold created while the query reader is suspended. */
	interactionName: string;
};

/**
 * The standard Suspense boundary for Confluence components that read data with native Relay hooks.
 *
 * Use this around the component that calls `useLazyLoadQuery` or `usePreloadedQuery`.
 * It delegates the fallback and hold lifecycle to Atlaskit's UFO Suspense implementation.
 */
export function RelaySuspense({
	children,
	fallback,
	interactionName,
}: RelaySuspenseProps): React.JSX.Element {
	return (
		<UFOSuspense fallback={fallback} interactionName={interactionName}>
			{children}
		</UFOSuspense>
	);
}
